module.exports = __webpack_public_path__ + "media/images/logo-sm-5b6576e3791db823bdbe230c9b0cf328.png";